<template>
  <div></div>
</template>

<script>
import { TimelineMax } from 'gsap';
import { mapState } from 'vuex';
// import { scroller } from 'vue-scrollto/src/scrollTo';
var VueScrollTo = require('vue-scrollto');

var __animMountedFlag = false;

export default {
  data() {
    return {
      nextRoute: null, // trigger next route
      fromRoute: null, // for parse on In state
      toRoute: null, // for parse on Out state
      playHeaderTitle: false,
      inited: false,
      lastNav: ''
    };
  },
  watch: {
    '$store.state.prevContentNav'(val) {
      this.lastNav = val;
    },
    $route(val) {
      this.$nextTick(() => {
        if (
          val.name === 'Psoriasis-section' ||
          val.name === 'Tremfya-section'
        ) {
          // if its section
          if (val.params.section === '1') {
            // its first section
            this.inTitleSection();
          } else if (
            val.params.section === '6' &&
            val.name === 'Tremfya-section'
          ) {
            // its Tremfya last section
            this.inTremfyaLast();
          } else if (this.headerTopLine === 'footer') {
            this.inFooterSection();
          } else {
            this.inSection();
          }
        } else if (val.params.section && val.params.subsection) {
          this.inSubsection();
        }

        // else if (val.params.subsection && this.bottomExpanded) {
        //   // } else if (val.params.subsection && !this.$store.getters.canScroll) {
        //   this.animateSubtitleAfterScroll('up', true);
        // }
      });
    },
    // headerBottomLine(val){
    //   console.warn('headerBottomLine', val);
    // },
    playHeaderTitle(val) {
      this.$store.commit('setPlayHeaderTitle', val);
    },
    bottomExpanded(val) {
      this.$nextTick(() => {
        this.animateSubtitleAfterScroll(val === true ? 'up' : 'down');
        // val && this.animateSubtitleAfterScroll('down');
      });
    },
    headerTopLine(val) {
      if (this.userAgent.isScrollLock) {
        return;
      }

      let tl;
      let topWave;
      let tlSettings = {
        onStart: () => {
          document.body.classList.add('block-pointer-events');
        },
        onComplete: () => {
          document.body.classList.remove('block-pointer-events');
        }
      };

      switch (val) {
        case 'menu':
          tl = new TimelineMax(tlSettings);
          topWave = document.querySelector('.header__section');

          if (topWave) {
            if (this.$route.params.subsection) {
              tl.fromTo(topWave, 0.5, { height: '86px' }, { height: '54vh' });
            } else {
              tl.to(topWave, 0.5, { height: '54vh' });
            }
          }
          break;
        case 'basic':
          tl = new TimelineMax(tlSettings);
          topWave = document.querySelector('.header__section');

          if (topWave) {
            if (
              this.$route.params.section === '4' ||
              this.$route.params.section === '5'
            ) {
              tl.fromTo(topWave, 0.5, { height: '54vh' }, { height: '86px' });
            } else {
              tl.to(topWave, 0.5, { height: '86px' });
            }
          }
          break;
      }
    },
    topExpanded() {
      if (!this.inited) {
        this.$nextTick(() => {
          this.inited = true;
          if (
            this.$route.name === 'Psoriasis-section' ||
            this.$route.name === 'Tremfya-section'
          ) {
            // if its section
            if (this.$route.params.section === '1') {
              // its first section
              this.inTitleSection();
            } else if (
              this.$route.params.section === '6' &&
              this.$route.name === 'Tremfya-section'
            ) {
              // its Tremfya last section
              this.inTremfyaLast();
            } else if (this.headerTopLine === 'footer') {
              this.inFooterSection();
            } else {
              this.inSection();
            }
          } else if (
            this.$route.params.section &&
            this.$route.params.subsection
          ) {
            this.inSubsection();
          }
        });
      }
    }
  },
  computed: {
    ...mapState(['userAgent']),
    isPrevSubsec() {
      // check - have lastNav, on same page, same section, last subsection was bigger
      if (
        this.lastNav !== '' &&
        this.lastNav.meta.page === this.$route.meta.page
      ) {
        if (
          (this.lastNav.params.section === this.$route.params.section &&
            parseInt(this.lastNav.params.subsection) >
              parseInt(this.$route.params.subsection)) ||
          parseInt(this.lastNav.params.section) >
            parseInt(this.$route.params.section)
        ) {
          return true;
        }
      }
      return false;
    },
    bottomExpanded() {
      return this.headerBottomLine === 'basic' ||
        this.headerBottomLine === 'burger'
        ? false
        : true;

      // return this.headerBottomLine === 'basic' || this.headerBottomLine === 'burger' ? true : false;
      // console.log('bottomExpanded',this.headerBottomLine === 'basic' || this.headerBottomLine === 'burger' ? false : true);
      // console.log('canScroll',this.$store.getters.canScroll);
      // return this.$store.getters.canScroll;
    },
    topExpanded() {
      return (
        (this.$store.getters.activeSubsection === undefined &&
          this.headerTopLine === 'title') ||
        (this.$store.getters.activeSubsection === undefined &&
          this.headerTopLine === 'section-1') ||
        (this.$store.getters.activeSubsection === undefined &&
          this.headerTopLine === 'footer')
      );
    },
    isAnimeting() {
      return this.$store.state.isTransitionAnimated;
    }
  },
  methods: {
    animationStarts() {
      // console.log('Animation Start');

      this.lockScroll();
      this.$store.commit('setTransitionAnimated', true);
      document.body.classList.add('block-pointer-events');
      // console.log('starts');
    },
    animationEnds() {
      // this.unlockScroll();
      // console.log('Animation End');

      this.$store.commit('setTransitionAnimated', false);
      document.body.classList.remove('block-pointer-events');

      if (this.nextRoute) {
        this.nextRoute();
        this.nextRoute = null;
      } else {
        this.unlockScroll();
      }
    },
    timeline() {
      return new TimelineMax({
        onStart: this.animationStarts,
        onComplete: this.animationEnds
      });
    },
    isLock() {
      return this.$store.state.isTransitionAnimated;
    },
    animateSubtitleAfterScroll(dirrection) {
      //, unlockAfterAnim = false
      if (this.userAgent.isScrollLock) {
        return;
      }

      // console.log(
      //   `--- animateSubtitleAfterScroll (${dirrection}) ---`,
      //   this.userAgent.isScrollLock
      // );

      let tl = new TimelineMax({
        onStart: () => {
          document.body.classList.add('block-pointer-events');
        },
        onComplete: () => {
          document.body.classList.remove('block-pointer-events');
        }
      });
      let subtitle = document.querySelector('.header__subsection');
      let topWave = document.querySelector('.header__section');

      if (topWave) {
        tl.set(topWave, { clearProps: 'all' });
      }

      if (subtitle) {
        // console.warn(`headerBottomLine - ${this.headerBottomLine} && dirrection - ${dirrection}`);

        // if its out anim
        // if(this.nextRoute){
        //   this.lockScroll();
        // }

        if (dirrection === 'down') {
          // collapse
          let headerSmallText = document.querySelector('.js-small-title-sub');

          tl.fromTo(subtitle, 0.5, { height: '61vh' }, { height: '85px' });

          if (headerSmallText) {
            tl.from(headerSmallText, 0.3, {
              y: '-200px',
              scale: 2,
              transformOrigin: 'top left',
              clear: 'all'
            }); // refactor to dynamic
          }
        }
        if (dirrection === 'up') {
          let headerTitleText = document.querySelector(
            '.header__sub-title .header-small__title-text'
          );

          // this.lockScroll();
          // if(this.nextRoute){
          //   this.lockScroll();
          // }

          this.playHeaderTitle = false;

          tl.fromTo(
            subtitle,
            0.5,
            { height: '85px' },
            // { height: '61vh', clear: 'all' }
            {
              height: this.headerBottomLine === 'menu-auto' ? '46vh' : '61vh',
              clearProps: 'all'
            }
          );

          if (headerTitleText) {
            tl.fromTo(headerTitleText, 0.3, { opacity: 0 }, { opacity: 1 });
            // tl.from(headerTitleText, 0.3, { opacity: '0' });
          }

          tl.set(this.$data, { playHeaderTitle: true }, '+=0');
        }
      }
    },
    inSubsection() {
      if (this.isLock()) {
        return;
      }

      let toPrevSubsec = this.isPrevSubsec;
      let tl = this.timeline();
      let sectionTitle = document.querySelector('.header-small__title');
      let subwave = document.querySelector('.header__subsection');

      this.playHeaderTitle = false;

      let headerSubsec = document.querySelector('.header__section');

      if (headerSubsec) {
        tl.set(headerSubsec, { clearProps: 'all' });
      }

      // animate section title
      if (sectionTitle) {
        tl.set(sectionTitle, { clearProps: 'all' });

        if (this.lastNav !== '') {
          if (
            (this.lastNav.meta.page === this.$route.meta.page &&
              this.lastNav.params.section !== this.$route.params.section) ||
            this.lastNav.meta.page !== this.$route.meta.page
          ) {
            tl.fromTo(sectionTitle, 0.5, { opacity: 0 }, { opacity: 1 });
          }
        }
      }

      // animate wave
      if (subwave) {
        let fromHeight = '85px';

        if (this.fromRoute && !this.fromRoute.params.subsection) {
          fromHeight = 0;
        }

        tl.fromTo(subwave, 0.5, { height: fromHeight }, { height: '85px' });

        // tl.to(subwave, .5, {height: '85px'});
      }

      if (toPrevSubsec === true) {
        let subtitle = document.querySelector('.header__sub-title');

        if (subtitle) {
          tl.fromTo(subtitle, 0.25, { opacity: 0 }, { opacity: 1 }, '+=0');
        }
      }

      tl.set(this.$data, { playHeaderTitle: true }, '+=0');
    },
    outSubsection() {
      if (this.isLock()) {
        return;
      }

      let tl = this.timeline();
      let botWave = document.querySelector('.header__subsection');
      let subTitle = document.querySelector('.header__sub-title');
      // let smallTitle = document.querySelector('.header-small__title');

      // if (smallTitle) {
      //   tl.set(smallTitle, { clearProps: 'all' });
      //   tl.fromTo(smallTitle, 0.25, { opacity: 1 }, { opacity: 0 }, 0);
      // }

      if (subTitle) {
        tl.set(subTitle, { clearProps: 'all' });
        tl.fromTo(
          subTitle,
          0.25,
          { opacity: 1 },
          { opacity: 0, clearProps: 'all' },
          0
        );
      }

      if (botWave) {
        tl.to(botWave, 0.25, { height: '85px' }, 0);
      }
    },
    outTitleSection(isNextSec = false) {
      if (this.isLock()) {
        // console.log('ANIM LOCKED ****');
        return;
      }
      // console.log('--- outTitleSection ---');
      let tl = this.timeline();
      let girl = document.querySelector('.sections-first-screen__image'); // get girl
      let screenTitle = document.querySelector('.sections-first-screen__title'); // screen title
      let screenNumber = document.querySelector(
        '.sections-first-screen__number'
      ); // screen number
      let pTags = document.querySelectorAll(
        '.sections-first-screen__content > p'
      ); // get text blocks
      let list = pTags ? Array.from(pTags) : []; // form array

      // this.lockScroll();

      list.unshift(girl); // add Girl on first position
      if (screenNumber) {
        list.push(screenNumber);
      }

      // tween out animation
      tl.staggerFromTo(list, 0.25, { opacity: 1 }, { opacity: 0 }, 0.25, 0);

      tl.fromTo(
        '.header__section',
        0.5,
        { height: '75vh' },
        { height: isNextSec === true ? '100vh' : '0', clearProps: 'all' },
        '+=0'
      );

      tl.fromTo(
        screenTitle,
        0.5,
        { transform: 'none', opacity: 1 },
        {
          transformOrigin: '0 0',
          transform: 'scale(.4, .4)',
          opacity: 0
        },
        '-=.65'
      );
    },
    inTitleSection() {
      if (this.isLock()) {
        // console.log('ANIM LOCKED ****');
        return;
      }
      // console.log('--- inTitleSection ---');
      let tl = this.timeline();
      let girl = document.querySelector('.sections-first-screen__image'); // get girl
      let screenTitle = document.querySelector('.sections-first-screen__title'); // screen title
      let screenNumber = document.querySelector(
        '.sections-first-screen__number'
      ); // screen number
      let pTags = document.querySelectorAll(
        '.sections-first-screen__content > p'
      ); // get text blocks
      let list = pTags ? Array.from(pTags) : []; // form array

      // hide title
      this.playHeaderTitle = false;

      // if (screenTitle) {
      //   list.unshift(screenTitle);
      //   tl.set(screenTitle, { clearProps: 'all' });
      // }

      if (screenNumber) {
        list.push(screenNumber);
      }

      tl.fromTo(
        '.header__section',
        0.5,
        // { height: '85px' },
        { height: '100vh' },
        { height: '75vh', clearProps: 'all' }
      );
      tl.fromTo(
        girl,
        0.5,
        { y: girl.scrollHeight },
        { y: 0, clearProps: 'all' },
        '+=0'
      );
      // tl.set(this.$data, { playHeaderTitle: true }, '-=.15');
      if (screenTitle) {
        // list.unshift(screenTitle);
        // tl.set(screenTitle, { clearProps: 'all' });
        tl.fromTo(
          screenTitle,
          0.5,
          { y: 100, opacity: 0 },
          { y: 0, opacity: 1, clearProps: 'all' },
          '+=0'
        );
        tl.set(this.$data, { playHeaderTitle: true }, '+=0');
      }

      tl.staggerFromTo(
        list,
        0.5,
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, clearProps: 'all' },
        0.25,
        screenTitle ? '+=1' : '+=0'
      );
      // tl.set(this.$data, { playHeaderTitle: true }, '-=.25');
    },
    outSection(isNextSec = false) {
      if (this.isLock()) {
        // console.log('ANIM LOCKED ****');
        return;
      }
      // this.lockScroll();

      // console.log('--- outSection ---');
      let tl = this.timeline();
      let img = document.querySelector('.sections-first-screen__image');

      if (img) {
        tl.set(img, { clearProps: 'all' });
        tl.fromTo(img, 0.5, { y: 0, opacity: 1 }, { y: -100, opacity: 0 }, 0.1);
      }

      tl.fromTo(
        '.sections-first-screen__title',
        0.25,
        { y: 0, opacity: 1 },
        { y: -100, opacity: 0 },
        0
      );

      tl.fromTo(
        '.header__section',
        0.5,
        { height: '75vh' },
        { height: isNextSec === true ? '100vh' : '0', clearProps: 'all' },
        '+=0'
      );

      tl.set('.sections-first-screen__title', { clearProps: 'all' }, '+=0');
    },
    inSection() {
      if (this.isLock()) {
        // console.log('ANIM LOCKED ****');
        return;
      }
      // console.log('--- inSection ---');
      let tl = this.timeline();
      let title = document.querySelector('.sections-first-screen__title');
      let bubble = document.querySelector('.sections-first-screen__image');

      // hide title
      this.playHeaderTitle = false;

      tl.set(title, { clearProps: 'all' });
      tl.fromTo(
        '.header__section',
        0.5,
        { height: '100vh' },
        { height: '75vh', clearProps: 'all' }
      );

      if (bubble) {
        tl.fromTo(
          bubble,
          0.5,
          { opacity: 0, y: -bubble.scrollHeight },
          { opacity: 1, y: 0, clearProps: 'all' }
        );
      }

      tl.set(this.$data, { playHeaderTitle: true }, '-=.25');
    },
    outFooterSection(isNextSec = false) {
      if (this.isLock()) {
        // console.log('ANIM LOCKED ****');
        return;
      }
      // console.log('--- outFooterSection ---');
      let tl = this.timeline();
      let arrow = document.querySelector('.footer__arrow');
      let cta = document.querySelector('.footer__cta');

      // this.lockScroll();

      if (arrow) {
        tl.fromTo(arrow, 0.25, { opacity: 1, x: 0 }, { opacity: 0, x: 100 });
      }
      if (cta) {
        tl.fromTo(cta, 0.25, { opacity: 1, y: 0 }, { opacity: 0, y: -100 }, 0);
      }

      tl.fromTo(
        '.header__section',
        0.5,
        { height: '75vh' },
        { height: isNextSec === true ? '100vh' : '0', clearProps: 'all' },
        '+=0'
      );
    },
    inFooterSection() {
      if (this.isLock()) {
        // console.log('ANIM LOCKED ****');
        return;
      }
      // console.log('--- inFooterSection ---');
      let tl = this.timeline();
      let arrow = document.querySelector('.footer__arrow');

      tl.fromTo(
        '.header__section',
        0.5,
        { height: '100vh' },
        { height: '75vh' }
      );

      if (arrow) {
        tl.fromTo(
          arrow,
          0.25,
          { opacity: 0, x: -100 },
          { opacity: 1, x: 0, clearProps: 'all' },
          '+=0'
        );
      }
    },
    inTremfyaLast() {
      if (this.isLock()) {
        return;
      }
      // console.log('--- inTremfyaLast ---');
      let tl = this.timeline();

      tl.set('.header__subsection', { height: '195px' });
      tl.fromTo(
        '.header__section',
        0.5,
        { height: '100vh' },
        { height: '62vh' }
      );
      // tl.fromTo('.header__subsection', 0.5, { height: '0' }, { height: '195px' }, '+=0');

      // tl.to('.header__section', 0.5, { height: '62vh' });

      tl.staggerFromTo(
        ['.footer', '.bottom-info'],
        0.5,
        { opacity: 0, y: -100 },
        { opacity: 1, y: 0 },
        0.25,
        '+=0'
      );
    },
    outTremfyaLast() {
      if (this.isLock()) {
        return;
      }
      // console.log('--- outTremfyaLast ---');
      let tl = this.timeline();

      // this.lockScroll();

      tl.staggerFromTo(
        ['.footer', '.bottom-info'],
        0.5,
        { opacity: 1, y: 0 },
        { opacity: 0, y: -100 },
        0.25
      );

      if (this.toRoute.params.subsection) {
        // tl.to('.header__subsection', 0.25, { height: 0 }, '+=0');
        tl.to(
          ['.header__section', '.header__subsection'],
          0.5,
          { height: '85px', force3D: true },
          '+=0'
        );
      } else {
        tl.to('.header__section', 0.5, { height: '100vh' }, '+=0');
      }

      tl.set(
        ['.header__section', '.footer', '.bottom-info'],
        { clearProps: 'all' },
        '+=0'
      );
    },
    // afterEach - helpers

    // Detect where to teleport instead of scroll (e.g Section 3 -> Subsection 2.7 || Section 1.1 -> Subsection 2.7 )
    teleport(to, from) {
      // console.log('<-', from, '->', to);
      // Skip direct link
      if (typeof from == 'undefined') {
        return false;
      }
      // Skip switcher
      if (to.meta.page !== from.meta.page) {
        // console.log('>> Tremfya<->Psoreasis');
        return false;
      }
      // Detect direction
      if (parseInt(to.params.section) != parseInt(from.params.section)) {
        // console.log('>> Teleport');
        return true;
      } else {
        // console.log('>> Scroll');
        return false;
      }
    }
  },
  mounted() {
    if (__animMountedFlag) return;
    __animMountedFlag = true;

    if (this.$route.params.subsection && this.bottomExpanded) {
      this.animateSubtitleAfterScroll('up');
    }

    // watch route before change navigation - run out anim
    this.$router.beforeEach((to, from, next) => {
      let isNextSec = to.name.includes('-section');

      this.fromRoute = from;
      this.toRoute = to;

      // if we move to another content type page - no out anim
      if (
        (from.name.includes('Psoriasis') && to.name.includes('Tremfya')) ||
        (from.name.includes('Tremfya') && to.name.includes('Psoriasis'))
      ) {
        next();
        return;
      }

      if (from.name !== 'Home') {
        this.$store.commit('setPrevContentNav', from);
        this.inited = true;

        if (
          from.name === 'Psoriasis-section' ||
          from.name === 'Tremfya-section'
        ) {
          this.nextRoute = next;

          // if its section
          if (from.params.section === '1') {
            // its first section
            this.outTitleSection(isNextSec);
          } else if (
            (from.params.section === '4' || from.params.section === '5') &&
            from.name === 'Tremfya-section' &&
            this.$store.state.headerStatus === 'basic'
          ) {
            this.outSubsection();
          } else if (
            from.params.section === '6' &&
            from.name === 'Tremfya-section'
          ) {
            this.outTremfyaLast();
          } else if (this.headerTopLine === 'footer') {
            this.outFooterSection(isNextSec);
          } else {
            this.outSection(isNextSec);
          }
        } else if (from.name.includes('-subsection')) {
          this.nextRoute = next;
          this.outSubsection();
        } else {
          next();
        }
      } else {
        next();
      }
    });

    // Watch router navigation to initiate subsection auto-scrolling/teleporting if required
    this.$router.afterEach((to, from) => {
      //Only for Desktop
      if (this.userAgent.device.isMobile) return;

      this.$nextTick(() => {
        let offset = 110; //window.innerHeight * 0.3;

        // Detect nav direction
        if (this.teleport(to, from)) {
          // Cases like 3->2.7

          let selector = to.params.hasOwnProperty('subsection')
            ? '#subsection-' + to.params.section + '-' + to.params.subsection
            : '#section-' + to.params.section;
          let tgt = document.querySelector(selector);
          let container = document.querySelector('.js-content');
          if (tgt) {
            container.scrollTop = tgt.offsetTop - offset;
          }
        } else {
          // Other cases
          // Create Scroller Object
          // let ScrollTo = scroller();

          let options = {
            container: '.js-content',
            easing: 'ease',
            offset: -offset,
            force: true,
            cancelable: false,
            x: false,
            y: true
          };

          VueScrollTo.scrollTo(
            '#subsection-' + to.params.section + '-' + to.params.subsection,
            1000,
            options
          );
        }
        //end if
      });
    });
  }
};
</script>
